/* src/app/_shared/components/content-title/content-title.component.scss */
.flow-content-title {
  margin: var(--space-top) var(--space-right) var(--space-bottom) var(--space-left);
  background-color: #FFFFFF;
  opacity: 1;
  transition: all 0.2s;
}
.flow-content-title.invisible {
  opacity: 0;
}
.flow-content-title h1 {
  margin: 0.5em 0;
}
/*# sourceMappingURL=content-title.component-BDW544BS.css.map */
